// Export all types from lesson.types.ts
export type {
  LessonDTO,
  SlideDTO,
  OptionDTO,
  AnswerDTO,
  LessonAnswerDTO,
  LessonAnswerReportDTO,
  LessonTypeConfig,
  ValidationRule,
  Lesson,
  Slide,
  Answer,
} from './lesson.types';

export { LessonType, Role } from './lesson.types';

// Export all types from slide.types.ts
export type {
  SlideData,
  OptionData,
  ValidationResult,
  SlideCapabilities,
  SlideCreationProps,
  SlideCompletionProps,
  SlidePreviewProps,
  SlideReportProps,
} from './slide.types';

export { SlideType } from './slide.types';

// Export all types from answer.types.ts
export type {
  AnswerData,
  LessonAnswerData,
  AnswerSubmission,
  AnswerValidation,
  LessonProgress,
} from './answer.types';